import React, { Component } from "react";
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import { connect } from "react-redux";
import Joyride from "react-joyride-react-19";
import { DIMENSIONS } from "services/layoutManager";
import { ActionButton } from "styled_components/Common/ActionButton";
import { LargeInfoDisplay } from "styled_components/Common/LargeInfoDisplay";
import { PortraitModalComponent } from "styled_components/Common/PortraitModalComponent";
import { CompanyModalBody } from "styled_components/Account/CompanyModalBody";
import { ModalFooter } from "styled_components/Common/ModalFooter";
import { ModalHeader } from "styled_components/Common/ModalHeader";
import { DataCenterApi } from "services/datacenter";
import { TicketApi } from "services/ticket";
import DonutChart from "sub_components/Common/DonutChart";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import { RESOLUTIONS } from "services/config";
import { TICKET_TYPES } from "utils/TicketConstants";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { updateUsers } from "actions/company";
import { MENU as PROFILE_MENU } from "utils/ProfileConstants";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import { Utils } from "services/utils";
import { UserApi } from "services/user";
import { BloxButton } from "styled_components/Common/BloxButton";
import { setHomeTour } from "actions/tour";
import { Permissions } from "services/permissions";
import { JoyRideToolTip } from "styled_components/Common/JoyRideToolTip";
import { updatePermissions } from "actions/permissions";
import { getUserPermissions, setUserPermissions } from "services/user";
import { CompanyProfileApi } from "services/companyProfile";
import { AvatarApi } from "services/avatar";
const CDN_URL = process.env.REACT_APP_CDN_URL;

const accountIcon = `${CDN_URL}profile/account-icon.svg`;
const documentIcon = `${CDN_URL}profile/document-icon.svg`;
const personIcon = `${CDN_URL}profile/person-icon.svg`;

const accountIconSelected = `${CDN_URL}profile/account-icon-selected.svg`;
const documentIconSelected = `${CDN_URL}profile/document-icon-selected.svg`;
const personIconSelected = `${CDN_URL}profile/person-icon-selected.svg`;

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    companyProfile: { x: 1, y: 43, dim: DIMENSIONS.TWO_BY_THREE },
    actionButton1: { x: 1, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    actionButton2: { x: 3, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    actionButton4: { x: 8, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    generalTickets: { x: 11, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    myProfile: { x: 5, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    myCompany: { x: 1, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    activities: { x: 9, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    companyProfile: { x: 1, y: 43, dim: DIMENSIONS.TWO_BY_THREE },
    actionButton1: { x: 1, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    actionButton2: { x: 3, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    actionButton4: { x: 5, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    generalTickets: { x: 11, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    myProfile: { x: 5, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    myCompany: { x: 1, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    activities: { x: 9, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    companyProfile: { x: 1, y: 43, dim: DIMENSIONS.TWO_BY_THREE },
    actionButton1: { x: 1, y: 5, dim: DIMENSIONS.TWO_BY_TWO },
    actionButton2: { x: 3, y: 5, dim: DIMENSIONS.TWO_BY_TWO },
    actionButton4: { x: 5, y: 5, dim: DIMENSIONS.TWO_BY_TWO },
    generalTickets: { x: 8, y: 5, dim: DIMENSIONS.TWO_BY_TWO },
    myProfile: { x: 4, y: 61, dim: DIMENSIONS.FOUR_BY_THREE },
    myCompany: { x: 1, y: 61, dim: DIMENSIONS.FOUR_BY_THREE },
    activities: { x: 7, y: 61, dim: DIMENSIONS.FOUR_BY_THREE },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
};
const LAYOUT_CONFIG2 = {
  [RESOLUTIONS.LOW]: {
    companyProfile: { x: 1, y: 43, dim: DIMENSIONS.TWO_BY_THREE },
    actionButton2: { x: 1, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    actionButton4: { x: 4, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    generalTickets: { x: 11, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    myProfile: { x: 5, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    myCompany: { x: 1, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    activities: { x: 9, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.MED]: {
    companyProfile: { x: 1, y: 43, dim: DIMENSIONS.TWO_BY_THREE },
    actionButton2: { x: 1, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    actionButton4: { x: 4, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    generalTickets: { x: 11, y: 0, dim: DIMENSIONS.TWO_BY_TWO },
    myProfile: { x: 5, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    myCompany: { x: 1, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    activities: { x: 9, y: 31, dim: DIMENSIONS.FOUR_BY_FOUR },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
  [RESOLUTIONS.HIGH]: {
    companyProfile: { x: 1, y: 43, dim: DIMENSIONS.TWO_BY_THREE },
    actionButton2: { x: 1, y: 5, dim: DIMENSIONS.TWO_BY_TWO },
    actionButton4: { x: 3, y: 5, dim: DIMENSIONS.TWO_BY_TWO },
    generalTickets: { x: 8, y: 5, dim: DIMENSIONS.TWO_BY_TWO },
    myProfile: { x: 4, y: 61, dim: DIMENSIONS.FOUR_BY_THREE },
    myCompany: { x: 1, y: 61, dim: DIMENSIONS.FOUR_BY_THREE },
    activities: { x: 7, y: 61, dim: DIMENSIONS.FOUR_BY_THREE },
    tourButton: { x: 0, y: 100, dim: DIMENSIONS.TWO_BY_TWO },
  },
};

class OverviewPage extends Component {
  constructor(props) {
    super(props);
    this.companyApi = new CompanyProfileApi();
    this.avatarApi = new AvatarApi();
    this.state = {
      expandedCard: null,
      users: null,
      rosterUsers: null,
      userDetails: null,
      role: null,
      rosterUserDetails: null,
      selectedInformation: "user",
      showTitleTicketCount: true,
      rosterUsersLoading: true,
      usersLoading: true,
      badges: null,
      portalLogs: null,
      badgeLogs: [],
      activitiesData: [],
      selectedIcon: null,
      tourClosed: false,
      showModal: false,
      description: "",
      bonitaTicketType: null,
      newChange: "",
      oldChange: "",
    };
  }

  componentWillUnmount() {
    Utils.removeHorizontalBar();
  }

  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      site,
      permissions,
      location,
      setHomeTour,
    } = this.props;

    const search = location?.search;

    if (search.includes("tour=true")) {
      setHomeTour({ runHomeTour: true, action: "start" });
    }

    updatePage(SITE_PAGES.PROFILE[PROFILE_MENU.OVERVIEW]);
    addPageToBreadCrumbs(
      SITE_PAGES.PROFILE[PROFILE_MENU.OVERVIEW],
      SITE_MODULES.ACCOUNT
    );
    if (site?.module !== "ACCOUNT" || !permissions?.permissions) {
      this.getModulePages();
    }
    updateModule(SITE_MODULES.ACCOUNT);

    this.checkForCompanyId();
    Utils.showHorizontalBar();
    this.getTicketType("support");
  }

  setChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  getTicketType = (type) => {
    TicketApi.getTicketType(type)
      .then((response) => {
        if (response.status === 200 && response?.data && !response.data.error) {
          this.setState({ bonitaTicketType: response?.data });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getPortalLogs = (role) => {
    const {
      auth_status: { user },
      company_info: { customer: { id } } = {},
    } = this.props;

    const params = {
      organizationId: id,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
    UserApi.getPortalAccessDetails(params)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;

        if (validResponse) {
          let logs = [];

          if (role.includes("member")) {
            let logs = response.data?.orgUserSessionList;
            const filterLogsUserOnly = logs.filter(
              (log) => log.email_address === user?.contactDetails?.email
            );

            logs = filterLogsUserOnly;
          } else {
            logs = response.data?.orgUserSessionList;
          }

          const activitiesData = this.formatActivitiesDataSession(logs);

          this.setState({ portalLogs: activitiesData });
        } else {
        }
      })
      .catch(() => {});
  };

  getSize = (breakpoint) => {
    let size = "medium";
    if (breakpoint === RESOLUTIONS.MED) {
      size = "medium";
    } else if (breakpoint === RESOLUTIONS.HIGH) {
      size = "medium";
    }

    return size;
  };

  getBadgeLogs = () => {
    const {
      company_info: { customer: { id } } = {},
      auth_status: { user } = {},
      permissions: pages,
    } = this.props;
    const { rosterUserDetails } = this.state;
    const hasBadgeViewAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-badge-logs"
    );
    if (hasBadgeViewAccess) {
      UserApi.getOrgDataCenterAccess(id, user?.id)
        .then((response) => {
          const validResponse = response.status === 200 && response.data;
          if (validResponse) {
            const activitiesData = this.formatActivitiesDataBadge(
              response.data?.dataCenterUserAccessLogs
            );

            this.setState({
              badgeLogs: activitiesData,
            });
          } else {
            this.setState({ error: "" });
          }
        })
        .catch(() => {
          this.setState({ error: "" });
        });
    } else {
      if (rosterUserDetails) {
        const params = {
          rosterUserId: rosterUserDetails?.id,
        };
        DataCenterApi.getBadgeDetails(params)
          .then((response) => {
            const validResponse = response.status === 200 && response.data;
            if (validResponse) {
              const badges = response.data?.badges;
              const badgeLogs = [];

              badges.forEach((badge) => {
                const logList = badge?.dataCenterUserAccessLogList;
                logList.forEach((log) => badgeLogs.push(log));
              });

              const activitiesData = this.formatActivitiesDataBadge(badgeLogs);

              this.setState({
                badgeLogs: activitiesData,
              });
            } else {
            }
          })
          .catch(() => {});
      }
    }
  };
  formatDescription = (description, browserInfo, userId, companyId) => {
    let desc = "";
    desc = `Description: ${description} \n`;
    desc += `Company: ${companyId}  \n`;
    desc += `Requestor: ${userId}  \n`;

    // Add shared user information if available
    const sharedUserData = sessionStorage.getItem("sharedUser");
    if (sharedUserData) {
      const { name, email } = JSON.parse(sharedUserData);
      desc += `Shared User Name: ${name}\n`;
      desc += `Shared User Email: ${email}\n`;
    }

    desc += `Time: ${format(new Date(), "HH:mm")}\n `;
    desc += `Previous Details: ${oldChange}\n`;
    desc += `New Details: ${newChange}\n`;
    desc += `Browser Info: ${browserInfo}  \n`;
    return desc;
  };

  createCompanySupportTicket = async () => {
    const { newChange, oldChange } = this.state;
    const {
      auth_status,
      company_info: { customer },
      site,
      auth_status: {
        user: {
          userProfile: { emailAddress },
        },
      },
    } = this.props;

    const browser_info = await Utils.getClientParams(site);
    const description = `Company Profile Update - Old Value: ${oldChange}\nNew Value: ${newChange}`;

    const ticket = {
      description,
      type: "Support",
      priority: "medium",
      userId: auth_status?.user?.id,
      companyId: customer?.id,
      browser_info,
      attachments: [],
      requester_id: auth_status?.user?.id,
      request_type: "support",
      status: "New",
      title: "Company Profile Update",
      requester_contact_value: emailAddress,
      internalTicketReference: "",
      requester:
        auth_status?.user?.firstname + " " + auth_status?.user?.lastname,
    };

    try {
      const response = await TicketApi.createTicket(ticket);
      if (response.status === 200 && !response.data.error) {
        this.setState({ showModal: false });
        sessionStorage.removeItem("tickets");
      }
    } catch (e) {
      console.log(e);
    }
  };

  formatActivitiesDataBadge = (badgeAccess) => {
    if (!badgeAccess) {
      return activitiesData;
    }
    const updatedActivitiesData = [];
    badgeAccess.map((log) => {
      const date = new Date(log?.messageDT);
      const displayDate = format(date, "MM-dd-yy");

      updatedActivitiesData.push({
        type: log?.messageType,
        city: log?.dataCenter,
        startDate: date,
        displayDate,
        timestamp: log?.messageDT,
      });
    });

    return updatedActivitiesData;
  };
  formatActivitiesDataSession = (portalSessions) => {
    if (!portalSessions) {
      return activitiesData;
    }

    const updatedActivitiesData = [];
    try {
      portalSessions.map((session) => {
        const timestamp = parseISO(session?.event_date);
        const displayDate = format(timestamp, "MM-dd-yy");

        updatedActivitiesData.push({
          type: session?.description,
          city: session?.city,
          startDate: timestamp,
          displayDate,
          timestamp,
        });
      });
    } catch (error) {
      console.log(error);
    }

    return updatedActivitiesData;
  };
  componentDidUpdate(prevProps) {
    const { location, setHomeTour } = this.props;
    this.checkForCompanyId();
    const search = location?.search;
    const prevSearch = prevProps?.location?.search;

    if (search !== prevSearch && search.includes("tour=true")) {
      setHomeTour({ runHomeTour: true, action: "start" });
    }
  }
  checkForCompanyId = () => {
    const {
      company_info: { customer: { id } = {} },
    } = this.props;
    const { organizationId: existingId, error } = this.state;

    if (id !== existingId && !error) {
      this.checkUsersPermissions(id);
      this.setState({ organizationId: id });
    }
  };
  getUsersRole = (id) => {
    const { auth_status } = this.props;
    const { role } = this.state;
    const { memberships = {} } = auth_status;
    const currentMembershipSelected = memberships.filter(
      (membership) => Number(membership.organizationId) === Number(id)
    );

    if (currentMembershipSelected[0].role !== role) {
      this.setState(
        { loggedInUsersRole: currentMembershipSelected[0].role },
        () => {
          this.getPortalLogs(currentMembershipSelected[0].role);
          this.getBadgeLogs(currentMembershipSelected[0].role);
        }
      );
    }
  };
  checkUsersPermissions = (id) => {
    const { auth_status: { user } = {} } = this.props;
    this.getUsersRole(id);
    this.setUserDetails(user);
    this.getRosterUsers(id, user.id);
  };

  getUsers(id, update) {
    const {
      company_info: { users = {} },
    } = this.props;
    if (update) {
      this.setState({ usersLoading: true });
    }
    if (users && !update) {
      this.setState({ users, organizationId: id, usersLoading: false });
    } else {
      UserApi.getAllUsers(id)
        .then((response) => {
          const validResponse = response.status === 200 && response.data;
          if (validResponse) {
            const { updateUsers } = this.props;
            updateUsers(response.data.users);
            this.setState({
              users: response.data.users,
              organizationId: id,
              usersLoading: false,
            });
          } else {
            this.setState({
              error: "Error pulling users",
              usersLoading: false,
            });
          }
        })
        .catch(() =>
          this.setState({ error: "Error pulling users", usersLoading: false })
        );
    }
  }
  setUserDetails = (user) => {
    const { userDetails } = this.state;
    if (userDetails !== user) {
      this.setState({ userDetails: user });
    }
  };
  getRosterUsers(id, userId) {
    DataCenterApi.getAllRosterUsers(id)
      .then((response) => {
        const validResponse = response.status === 200 && response.data;
        if (validResponse) {
          this.setState(
            {
              rosterUsers: response.data.rosterUsers,
              organizationId: id,
              rosterUsersLoading: false,
            },
            () => {
              this.getRosterUserDetails(userId);
            }
          );
        } else {
          this.setState({
            error: "Error pulling users",
            rosterUsersLoading: false,
          });
        }
      })
      .catch(() =>
        this.setState({
          error: "Error pulling users",
          rosterUsersLoading: false,
        })
      );
  }

  getLayoutConfig = (breakpoint) => {
    const config = LAYOUT_CONFIG[breakpoint];

    return config;
  };

  getLayoutConfig2 = (breakpoint) => {
    const config = LAYOUT_CONFIG2[breakpoint];

    return config;
  };

  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;

    const permissions = getUserPermissions("account");
    if (!permissions) {
      const response = await Permissions.getModulePermissions(3, userId, orgId);
      if (response && !response.data.error) {
        setUserPermissions("account", response.data.pages);
        updatePermissions(response.data.pages);
      }
    } else {
      updatePermissions(permissions);
    }
  };
  goToTicketHistory = (status) => {
    const { navigate } = this.props;

    navigate("/portal/support/ticket_history", {
      state: { status, type: "General" },
    });
  };
  showTitleTicketCount = (show) => {
    const { showTitleTicketCount } = this.state;

    if (showTitleTicketCount !== show) {
      this.setState({ showTitleTicketCount: show });
    }
  };

  getRosterUserDetails = (id) => {
    if (!id) {
      return id;
    }
    const { rosterUsers, rosterUserDetails, role } = this.state;
    if (rosterUsers) {
      const filteredUsers = rosterUsers.filter(
        (user) => user.userId === parseInt(id)
      );
      if (filteredUsers && filteredUsers[0]) {
        if (rosterUserDetails !== filteredUsers[0]) {
          this.setState({ rosterUserDetails: filteredUsers[0] }, () => {
            this.getBadgeLogs(role);
          });
        }
      }
    }
  };

  setActive = (id, page) => {
    const element = document.getElementById(id);
    element.classList.toggle("active");

    if (document.getElementById(`${id}trans2`)) {
      document.getElementById(`${id}trans2`).beginElement();
    }
    if (document.getElementById(`${id}trans3`)) {
      document.getElementById(`${id}trans3`).beginElement();
    }
    setTimeout(() => this.goToPage(page), 1000);
    this.setState({ selectedIcon: page });
  };

  formatDataUser = () => {
    const {
      auth_status,
      auth_status: { user },
      auth_status: {
        user: { firstname, lastname },
      },
      company_info,
    } = this.props || {};
    const { memberships = {} } = auth_status;
    const profileImage = user?.userProfile
      ? this.avatarApi.getUserAvatar(user)
      : this.avatarApi.getGenericAvatar();
    const usersName = firstname + " " + lastname;
    const contact = user?.contactDetails;
    const address = `${contact?.address} ${contact?.city} ${contact?.state} ${contact?.city}`;

    const currentMembershipSelected = memberships.filter(
      (membership) =>
        Number(membership.organizationId) === Number(company_info?.fuseBillId)
    );

    const role = currentMembershipSelected[0]?.role;
    return {
      header: {
        image: profileImage,
        title: usersName,
        details1: role,
      },
      main: {
        title: "MY Profile",
        fields: [
          { label: "EMAIL", value: user?.userProfile?.emailAddress },
          { label: "PHONE", value: user?.contactDetails?.mobile_number },
          { label: "ADDRESS", value: address },
        ],
      },
      footer: {
        buttonID: "user-profile",
        buttonText: "EDIT INFO",
        onClick: () => {},
      },
    };
  };

  formatDataCompany = () => {
    const {
      company_info: { customer, addressPreferences },
    } = this.props || {};
    const address = addressPreferences?.billingAddress;
    const billingAddress = `${address?.line1 ? address?.line1 : ""}  ${
      address?.line2 ? address?.line2 : ""
    } ${address?.postalZip ? address?.postalZip : ""} ${
      address?.state ? address?.state : ""
    }`;

    const businessAddress = `${customer?.adress1} 
		 ${customer?.city}  ${customer?.state}  ${customer?.zip} `;

    return {
      header: {
        image: this.companyApi.getCompanyAvatar(),
        title: customer?.companyName,
        details1: "",
      },
      main: {
        title: "COMPANY Profile",
        fields: [
          {
            label: "CONTACT",
            value: addressPreferences?.contactName
              ? addressPreferences?.contactName
              : customer?.contactName,
          },
          {
            label: "EMAIL",
            value: customer?.primaryEmail
              ? customer?.primaryEmail
              : customer?.email,
          },
          {
            label: "PHONE",
            value: customer?.primaryPhone
              ? customer?.primaryPhone
              : customer?.phone,
          },
          {
            label: "ADDRESS",
            value: billingAddress !== "    " ? billingAddress : businessAddress,
          },
        ],
      },
      footer: {
        buttonID: "company-profile",
        buttonText: "EDIT INFO",
        onClick: () => {},
      },
    };
  };

  submitTickets = () => {
    const { bonitaTicketType } = this.state;
    if (bonitaTicketType?.bonita) {
      this.createCompanySupportTicket();
    }
  };

  getModalFooter = (breakpoint, newChange, oldChange) => {
    return (
      <ModalFooter
        cypressId="footer"
        id="footer"
        buttonText1={"Submit"}
        buttonActive1={
          newChange.length >= 10 && oldChange.length >= 10 ? true : false
        }
        buttonActive2={true}
        module="account"
        buttonFunction1={this.submitTickets}
        size={this.getSize(breakpoint)}
      />
    );
  };

  closeTour = (joyride) => {
    const { setHomeTour, navigate } = this.props;

    const action = joyride?.action;

    if (action === "close" || action === "reset" || action === "stop") {
      setHomeTour({ runHomeTour: false, action });
      this.setState({ tourClosed: true });
      navigate("/portal/account");
    }
  };

  goToPage = (page) => {
    const { navigate } = this.props;
    navigate(`/portal/account/${page}`);
  };

  toggleModal = () => {
    const { showModal } = this.state;
    this.setState({ showModal: !showModal, description: "" });
  };

  getIcon = (selectedIcon) => {
    return (
      <div className="icon">
        <img
          src={
            selectedIcon === "documents" ? documentIconSelected : documentIcon
          }
        />
      </div>
    );
  };

  render() {
    const {
      breakpoint,
      location,
      permissions: pages,
      site,
      auth_status: { user } = {},
      navigate,

      tour: { runHomeTour: { runHomeTour } } = {},
    } = this.props || {};
    const {
      role,
      badgeLogs,
      portalLogs,
      selectedIcon,
      showModal,
      bonitaTicketType,
      newChange,
      oldChange,
    } = this.state;
    const moduleOrder = location?.state?.moduleOrder;

    const hasCompanyProfileAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-organization"
    );
    const hasMyProfileAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-account"
    );
    const hasDocumentAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-documents"
    );

    const hasAccountManagementAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "account-management"
    );

    const hasNotificationsAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-updates"
    );
    const hasTicketStatusAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "view-ticket-status"
    );

    let activityData = [];

    activityData = badgeLogs.concat(portalLogs);
    if (activityData?.length !== 0) {
      activityData = Utils.sort(activityData);
    }

    const module = site?.module;

    const steps = [
      {
        title: "Account Overview",
        content:
          "In here, you can manage view your account details, add new users and edit permissions.",
        placement: "center",
        locale: { skip: "S-K-I-P" },
        target: ".header-section",
        module: "account",
      },
      {
        target: "#large-info-card-company",
        module: "account",
        disableBeacon: true,
        content:
          "In the My Company you will find your organization's information. Everything looks great to me. Let's continue…",
      },
      {
        target: "#large-info-card-my-profile",
        module: "account",
        content:
          "Next to the My Company section, you will see the My Profile section with your basic user information. I will show you how to modify this information later and how to change your profile picture. Let's move on…",
      },
      {
        target: "#large-info-card-notifications",
        module: "account",
        content:
          "In this area called Notifications, you will be able to get a quick look at user-generated events like portal logins. If you were (after this demo) to click on the View More button, I could show you more information.",
      },
      {
        target: ".donut-chart-container",
        module: "account",
        disableBeacon: true,
        content:
          "Up here is how we show you support tickets specific to the Account module. These doughnuts are found in each module and, when clicked, will take you to the Support module, but we will review that later.",
      },
      {
        content:
          "Next, we should look at your profile information. You must be curious about how to change your profile image.",
        customNextButton: (
          <BloxButton
            className="buttons41"
            id="continue-tour"
            text="Next"
            module="account"
            enabled={true}
            onClick={() =>
              navigate("/portal/account/my_profile?tour=true", {
                state: { moduleOrder },
              })
            }
            cypressId="continue-tour"
          />
        ),
        showBackButton: false,
        disableBeacon: true,
        module: "account",
        target: ".header-section",
        placement: "center",
      },
    ];
    return (
      <>
        <BloxPage
          name="page profile-overview-page"
          layout={
            hasAccountManagementAccess
              ? this.getLayoutConfig(breakpoint)
              : this.getLayoutConfig2(breakpoint)
          }
          breakpoint={breakpoint}
          location={location}
        >
          <div key={`generalTickets`} className="generalTickets">
            {hasTicketStatusAccess && (
              <ComponentWrapper
                title="General Tickets"
                hideBorder
                titleClass="center"
              >
                <DonutChart
                  ticketType={TICKET_TYPES.SUPPORT}
                  showTitle={this.showTitleTicketCount}
                  goToTicketHistory={this.goToTicketHistory}
                  id="account"
                  breakpoint={breakpoint}
                  navigate={navigate}
                  pages={pages}
                  ticketTypePermission={bonitaTicketType}
                />
              </ComponentWrapper>
            )}
          </div>
          <div key={`tourButton`} className="tourButton">
            {pages && (
              <Joyride
                steps={steps}
                continuous={true}
                tooltipComponent={JoyRideToolTip}
                run={runHomeTour}
                styles={{
                  options: {
                    zIndex: 5000,
                  },
                }}
                module={module}
                callback={this.closeTour}
                spotlightPadding={5}
                disableScrolling={true}
                disableBeacon={true}
                disableOverlayClose={true}
              />
            )}
          </div>
          <div key={`actionButton1`} className="actionButton1">
            {hasAccountManagementAccess && (
              <ComponentWrapper title="Portal Administration" hideBorder>
                <ActionButton
                  id="special-id-1"
                  onClick={() =>
                    this.setActive("special-id-1", "account_management")
                  }
                  module={module}
                  className="medium"
                  cypressId="account-management-button"
                  navigate={navigate}
                >
                  <div className="icon">
                    <img
                      src={
                        selectedIcon === "account_management"
                          ? accountIconSelected
                          : accountIcon
                      }
                    />
                  </div>
                  <div className="action-button-text buttons27">Account</div>
                </ActionButton>
              </ComponentWrapper>
            )}
          </div>
          <div key={`actionButton2`} className="actionButton2">
            {hasMyProfileAccess && (
              <ComponentWrapper
                title={
                  hasAccountManagementAccess ? "" : "Portal Administration"
                }
                hideBorder
              >
                <ActionButton
                  id="special-id-2"
                  onClick={() => this.setActive("special-id-2", "my_profile")}
                  className="medium"
                  module={module}
                  cypressId="my-profile-button"
                  navigate={navigate}
                >
                  <div className="icon">
                    <img
                      src={
                        selectedIcon === "my_profile"
                          ? personIconSelected
                          : personIcon
                      }
                    />
                  </div>
                  <div className="action-button-text buttons27">My Profile</div>
                </ActionButton>
              </ComponentWrapper>
            )}
          </div>

          <div key={`actionButton4`} className="actionButton4">
            {hasDocumentAccess && (
              <ComponentWrapper title="Documents" hideBorder>
                <ActionButton
                  id="special-id-4"
                  onClick={() => this.setActive("special-id-4", "documents")}
                  module={module}
                  className="medium"
                  cypressId="documents-button"
                  navigate={navigate}
                >
                  {this.getIcon(selectedIcon)}
                  <div className="action-button-text buttons27">Documents</div>
                </ActionButton>
              </ComponentWrapper>
            )}
          </div>
          <div key={`myProfile`} className="myProfile">
            {hasMyProfileAccess && (
              <ComponentWrapper title="My Profile" hideBorder>
                <LargeInfoDisplay
                  type="default"
                  data={this.formatDataUser()}
                  module={module}
                  onClick={() => this.goToPage("my_profile")}
                  user={user}
                  role={role}
                  cypressId="LI-my-profile-link"
                  navigate={navigate}
                  id="my-profile"
                />
              </ComponentWrapper>
            )}
          </div>

          <div key={`myCompany`} className="myCompany">
            {hasCompanyProfileAccess && (
              <ComponentWrapper title="My Company" hideBorder>
                <LargeInfoDisplay
                  type="default"
                  data={this.formatDataCompany()}
                  module={module}
                  onClick={this.toggleModal}
                  user={user}
                  role={role}
                  navigate={navigate}
                  id="company"
                />
              </ComponentWrapper>
            )}
          </div>

          <div key={`activities`} className="activities">
            {hasNotificationsAccess && (
              <ComponentWrapper title="Activities" hideBorder>
                <LargeInfoDisplay
                  type="activities"
                  data={activityData}
                  onClick={() => this.goToPage("notifications")}
                  user={user}
                  role={role}
                  cypressId="LI-notifications-link"
                  navigate={navigate}
                  id="notifications"
                  image={this.companyApi.getCompanyAvatar()}
                />
              </ComponentWrapper>
            )}
          </div>
        </BloxPage>
        <PortraitModalComponent
          closeModal={this.toggleModal}
          show={showModal}
          header={
            <ModalHeader image={this.companyApi.getCompanyAvatar()} text={""} />
          }
          subTitle={"What would you like to change?"}
          title="Company Profile"
          size={this.getSize(breakpoint)}
          breakpoint={breakpoint}
        >
          <CompanyModalBody
            breakpoint={breakpoint}
            setChange={this.setChange}
            newChange={newChange}
            oldChange={oldChange}
          />
          {this.getModalFooter(breakpoint, newChange, oldChange)}
        </PortraitModalComponent>
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    site: state.site_tracking,
    permissions: state.permissions,
    tour: state.tours,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
  updateUsers,
  updatePermissions,
  setHomeTour,
})(OverviewPage);
